/**************************************************************************************************************************************************
*   MODULE NAME     :  Metric Actions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  14-04-2021
*   DESCRIPTION     :  Metric API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import MetricsApi from "../api/MetricsApi";

export const loadOtherMetrics = (data) => {
    return async () => {
      try {
        return await MetricsApi.getOtherMetrics(data);
      } catch (error) {
        return error;
      }
    }
  }

  export const loadOtherMetricsPagination = (data) => {
    return async () => {
      try {
        return await MetricsApi.getOtherMetricsPagination(data);
      } catch (error) {
        return error;
      }
    }
  }

  export const loadAggregateMetrics = (data) => {
    return async () => {
      try {
        return await MetricsApi.getAggregateMetrics(data);
      } catch (error) {
        return error;
      }
    }
  }